import { createElement, useRef, useState } from 'react';
import { Calendar } from '@nutui/nutui-react';
import cls from 'classnames/bind';
import style from './index.module.scss';
import { Date } from '@nutui/icons-react';
import dayjs from 'dayjs';
import { Button } from '@nutui/nutui-react';
const cx = cls.bind(style);
const RangePreset = {
    上月: [
        dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
        dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
    ],
    本月: [
        dayjs().startOf('month').format('YYYY-MM-DD'),
        dayjs().endOf('month').format('YYYY-MM-DD'),
    ],
    下月: [
        dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD'),
        dayjs().add(1, 'month').endOf('month').format('YYYY-MM-DD'),
    ],
};
const btns = ['上月', '本月', '下月'];
const DateRangePicker = (props) => {
    const { value, onChange, name } = props;
    const [visible, setVisible] = useState(false);
    const [date, setDate] = useState([]);
    const calendarRef = useRef(null);
    const openCalendar = () => {
        setDate(value || []);
        setVisible(true);
    };
    const onClose = () => {
        setVisible(false);
    };
    const formatChange = (value) => {
        onChange(value.map((e) => e[3].replace(/\//g, '-')));
    };
    const getCurentMonth = (type) => {
        const dates = RangePreset[type];
        setDate(dates);
        if (calendarRef.current) {
            calendarRef.current.scrollToDate(dates[0]);
        }
    };
    const renderHeaderButtons = () => {
        return (createElement("div", null, btns.map((item) => (createElement("span", { className: "d_btn", onClick: () => getCurentMonth(item) },
            createElement(Button, { fill: "outline", color: "#3F9BE6", size: 'mini', style: {
                    margin: 8,
                } }, item))))));
    };
    return (createElement("div", { className: cx('dateRangePicker') },
        createElement("div", { className: cx('triger'), onClick: openCalendar },
            name,
            createElement(Date, null)),
        createElement(Calendar, { ref: calendarRef, type: "range", startDate: "2022-12-22", visible: visible, defaultValue: date, onClose: onClose, onConfirm: formatChange, renderHeaderButtons: renderHeaderButtons })));
};
export default DateRangePicker;
